import { Component } from '@angular/core';

@Component({
  selector: 'app-student-attendance',
  imports: [],
  templateUrl: './student-attendance.component.html',
  styleUrl: './student-attendance.component.scss'
})
export class StudentAttendanceComponent {

}
